// Module
var code = "<input class=form-control ng-disabled=ngDisabled name=nlgNumberInput type=text ng-blur=change() autocomplete=off data-cy={{cyName}} />";
// Exports
module.exports = code;